import styled from "@yb/styled-px2rem";
import {TextareaProps} from "@FRAMEWORK/ui/types/d";

interface Props extends TextareaProps {
	width?: string;
	height?: string;
}

const TextareaSelect = styled.textarea<Props>`
	display: block;
	width: 100%;
	height: ${props => (props.height ? props.height : "")};
	padding: 10px;
	border: 1px solid var(--line-color);
	appearance: none;
	box-shadow: none;
	border-radius: 0;
	box-sizing: border-box;
	-webkit-text-size-adjust: none;
	-webkit-border-radius: none;
	-webkit-appearance: none;
	font-family: "PT-regular";
	font-size: 15px;
	color: var(--default-color);
	resize: none;
	outline: none;
`;

const Textarea = ({width, height, ...props}: Props) => <TextareaSelect width={width} height={height} {...props} />;

export default Textarea;
